// src/api_scripts/createTeam.js
import { createApiClient } from "../apiClient";

const createTeam = async (teamData, orgId, accessToken, setProgress) => {
  const { name } = teamData.name;

  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create Team: "${name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);

  // API endpoint for creating a new  Team
  const relativeUri = `organization/${orgId}/team`;

  try {
    const apiClient = createApiClient(accessToken);
    const response = await apiClient.post(relativeUri, teamData);

    const newTeam = response.data; // The API returns the created resource directly

    console.log("Create Team API Response Data:", newTeam);

    setProgress((prev) => [
      ...prev,
      { type: 'success', message: `Successfully created Team "${name}" (ID: ${newTeam.id}).`, timestamp: new Date().toLocaleTimeString() }
    ]);

    return newTeam.id; // Return the created override list object (includes its ID)

  } catch (error) {
    console.error(`Error creating Team "${name}":`, error);

    let errorMessage = `Error creating Team "${name}": ${error.message || String(error)}`;

    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error;
  }
};

export default createTeam;
